module.exports = __webpack_public_path__ + "img/app.8383c6f0.png";